// extracted by mini-css-extract-plugin
export default {"card":"Card_card__x014g","p":"Card_p__rEl27"};